import {
	requestRegistMemo,
} from "@/apis/memo_api";

import router from "@/router";

const state = {
};

const getters = {
};


const mutations = {

};

const actions = {
	async REQUEST_REGIST_MEMO(context,parameter) {
		try {
			context.commit('START_LOADING');
            const response = await requestRegistMemo(parameter);
			if (response.data !== null && response.data !== undefined && response.data.result === 'success') {
				

			} else {
				alert(response.data.message);
			}
			context.commit('END_LOADING');
		} catch (e) { if(e==='refresh'){ return }
			context.commit('END_LOADING');
		}
	},
};

export default { mutations, state, actions, getters };